// 小米负一屏go机型
export default {
  // 小米天气的小部件英文域名
  "en-miwg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 小米印地语域名
  "hi-miwg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 小米印尼语域名
  "id-miwg.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: undefined,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
};
